import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [error, setError] = useState("");

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("pb_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("pb_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (pin) => {
    setError("");
    const { data } = await api.post("/auth/login", { pin });
    localStorage.setItem("pb_token", data.token);
    try {
      const { data: ld } = await api.get("/locations");
      const locs = ld.locations || [];
      const cur = localStorage.getItem("pb_location");
      const valid = data.user.role === "owner" ? (cur === "all" || locs.find((l) => l.id === cur)) : locs.find((l) => l.id === cur);
      if (!valid) localStorage.setItem("pb_location", locs[0]?.id || "");
    } catch (e) { console.error("Failed to preload locations after login", e); }
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("pb_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error, setError, refreshUser: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
